import React from 'react';
import { Grid } from '@mui/material';
import { ViewMoreLink } from 'components/common/ViewMoreLink';
import { EmptyContainer } from 'shared-components/EmptyContainer';
import { MyDataWrapper, MyDataHeader, Title, MyDataContent } from './styles';
import { MyDataCard } from 'components/MyDataCard';

import { mockData } from 'pages/MyData/mockData';

export const MyData = () => {
  const data = mockData.filter((value, index) => index < 4);

  return (
    <MyDataWrapper
      sx={{ margin: '57px 0' }}>
      <MyDataHeader
        sx={{
          display       : 'flex',
          flexDirection : { xs: 'column', md: 'row' },
        }}>
        <Title>My data making a difference</Title>
        <ViewMoreLink
          to={'/homepage/my-data-making-a-difference'}>
          View all
        </ViewMoreLink>
      </MyDataHeader>

      <MyDataContent
        isEmpty={!data.length}>
        {data.length && (
          <Grid
            container spacing={1}>
            {data.map((item) => (
              <Grid
                key={item.id}
                item
                md={6}
                lg={3}
                sx={{ display: 'flex', flex: 1 }}>
                <MyDataCard
                  item={item}
                />
              </Grid>
            ))}
          </Grid>
        )}
        {!data.length && (
          <EmptyContainer
            title='No data yet'
            description='Start by filling daily survey so we can show how your data is making an impact.'
            ctaText='Start'
          />
        )}
      </MyDataContent>
    </MyDataWrapper>
  );
};
